import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { H2, Hints } from '.';
import { colors } from '../utils';
import { formatTimespan } from '../utils/utils';
import { getMetrics as getMetricsAction } from '../lib/redux/actions/me';

const MetricsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: white;
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  width: 827px;
`;

const Metric = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  padding-left: 4rem;
  padding-right: 4rem;
`;

const MetricsValue = styled(H2)`
  font-weight: 500;
`;

const MetricsLabel = styled(Hints)`
  color: ${colors.g04};
`;

function AgentMetrics({ metrics, getMetrics, metricsDuration }) {
  useEffect(() => {
    getMetrics();
  }, [metricsDuration]);

  return (
    <MetricsWrapper>
      <Metric>
        <MetricsValue>{metrics.callCount}</MetricsValue>
        <MetricsLabel>Total Number of Calls</MetricsLabel>
      </Metric>
      <Metric>
        <MetricsValue>{formatTimespan(metrics.activeTime)}</MetricsValue>
        <MetricsLabel>Total Available Time</MetricsLabel>
      </Metric>
      <Metric>
        <MetricsValue>{formatTimespan(metrics.recordingTime)}</MetricsValue>
        <MetricsLabel>Total Recording Time</MetricsLabel>
      </Metric>
    </MetricsWrapper>
  );
}

AgentMetrics.propTypes = {
  metrics: PropTypes.shape({
    callCount: PropTypes.number,
    activeTime: PropTypes.string,
    recordingTime: PropTypes.string
  }).isRequired,
  getMetrics: PropTypes.func.isRequired,
  metricsDuration: PropTypes.number.isRequired
};

export default connect(
  state => ({
    metrics: state.me.metrics,
    metricsDuration: state.me.metricsDuration
  }),
  {
    getMetrics: getMetricsAction
  }
)(AgentMetrics);
